'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaserCe = require('phaser-ce');

var _phaserCe2 = _interopRequireDefault(_phaserCe);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {
      this.loaderBg = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBg');
      this.loaderBar = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBar');
      (0, _utils.centerGameObjects)([this.loaderBg, this.loaderBar]);
      this.load.setPreloadSprite(this.loaderBar);

      /**
       * Load resources from other domain (CORS is required)
       */
      //this.load.baseURL = 'http://www.nicholls.co/'
      //this.load.crossOrigin = 'anonymous'

      /**
       * Load the assets
       */
      this.load.image('level1', 'assets/images/level1.jpg');

      this.load.image('bullet', 'assets/images/bullet.png');
      this.load.spritesheet('player', 'assets/images/player.png', 80, 90);
      this.load.spritesheet('legs', 'assets/images/legs.png', 80, 100);

      this.load.audio('music', ['assets/audios/music.ogg', 'assets/audios/music.mp3']);
      this.load.audio('shoot', ['assets/audios/shoot.ogg', 'assets/audios/shoot.mp3']);
    }
  }, {
    key: 'create',
    value: function create() {
      this.state.start('Game');
    }
  }]);

  return _class;
}(_phaserCe2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Splash.js
// module id = 359
// module chunks = 0